import React from 'react';
import styled from 'styled-components';
import TextInput from 'sub_components/Common/BloxTextInput';
import { INPUT_TYPES } from 'utils/Misc/CommonConstants';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';

const emailValidations = [
	{ message: 'Required field', pattern: /.+/ },
	{ message: 'Please enter a valid email address.', pattern: /^[^@\s]+@[^@\s]+\.[^@\s]+$/ },
];

const HelpBodyStyle = styled.button`
	width: 100%;
	height: 280px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	border: none;
	background-color: transparent;
	color: ${props => props.theme.defaultFontColor};
	.email-block {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		padding-bottom: 10px;
		text-align: left;
		.title {
			line-height: 20px;
			padding-bottom: 10px;
		}
	}
	.steps {
		margin-bottom: 10px;
		.step {
			margin-bottom: 10px;
		}
	}
	.success-wrapper {
		.link {
			cursor: pointer;
			text-decoration: underline;
		}
	}
	.help-inputs-wrapper {
		text-align: left;
		padding-bottom: 10px;
		width: 100%;
		.title {
			line-height: 20px;
			padding-bottom: 10px;
		}
		.description-body {
			border: 1px solid ${props => props.theme.Cool_Gray_Light_1};
			width: 285px;
			height: 136px;
			overflow: hidden;

			.blox-text-input {
				width: 330px;
				height: 150px;
				padding: 10px;
				.text-area-description {
					min-height: 90px;
				}
				.active-field {
					min-height: 90px;
					max-height: 100px;
				}
				.checkmark,
				.label-row,
				.validation-row {
					display: none;
				}
			}

			.ScrollbarsCustom-TrackY:before {
				border-left: none;
			}
		}
		.help-inputs {
			width: 100%;
			.blox-text-input {
				padding-bottom: 10px;
			}
		}
	}
	.message-large {
		margin-top: 5px;
		margin-bottom: 5px;
	}
	img {
		width: 100px;
		height: 100px;
	}
	.ScrollbarsCustom-Track {
		right: -20px !important;
		top: 0px !important;
	}
	.ScrollbarsCustom-ThumbY {
		background-color: ${props => props.theme.support} !important;
		width: 6px !important;
	}
	.ScrollbarsCustom-TrackY:before {
		border-left: none;
	}
	.ScrollbarsCustom-TrackY {
		background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
		box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
			1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
		width: 6px !important;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		height: 220px;

		.help-inputs-wrapper {
			.description-body {
				width: 336px;
			}
		}
		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.support} !important;
			width: 8px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 8px !important;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		height: 380px;
		.help-inputs-wrapper {
			.description-body {
				width: 336px;
			}
		}
		.steps {
			margin-bottom: 20px;
			.step {
				margin-bottom: 20px;
			}
		}
		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${props => props.theme.support} !important;
			width: 10px !important;
		}

		.ScrollbarsCustom-TrackY {
			background-color: ${props => props.theme.Cool_Gray_Light_2} !important;
			box-shadow: -1px -1px 1.5px ${props => props.theme.Cool_Gray_Light_3} inset,
				1px 1px 1.5px ${props => props.theme.Cool_Gray_Med_2} inset;
			width: 10px !important;
		}
	}
`;

export const HelpBody = ({
	id,
	module,
	cypressId,
	customClass,
	onChange,
	email,
	description,
	navigate,
	success,
	error,
	breakpoint,
	area,
	toggleOpen,
}) => {
	function goToSupport() {
		toggleOpen();
		navigate('/portal/support');
	}

	return (
		<HelpBodyStyle
			id={id}
			className={`help-modal-wrapper ${customClass} `}
			module={module}
			data-cy={cypressId}
		>
			<ScrollView>
				<div className='help-inputs-wrapper'>
					{area !== 'portal' && (
						<div className='steps body10'>
							<div className='step'>
								1. Search your email inbox for an email with a subject containing "MyDCBlox Account
								Has Arrived". This email verifies that your email account is provisioned with the
								site. If you do not have this email then look into other email accounts you may
								have.
							</div>
							<div className='step'>
								2. Click on the "Forgot your password?" link on the login screen to reset your
								password, and follow the steps in the email to reset the password and login.
							</div>
							<div className='step'>
								If you no longer have access to the email address you are registered with or can no
								longer login, even after attempting these steps, send us a note using the form
								below. Additionally, contact your account administrator if you need further help.
							</div>
						</div>
					)}
					<div className='title heading60'>Ticket:</div>

					{!success && !error && area !== 'portal' && (
						<>
							<div className='title body10'>
								If you'd like to contact our support team directly please enter your details below
								and click submit.
							</div>
							<div className='help-inputs'>
								<TextInput
									placeholder='EMAIL'
									active={true}
									type={INPUT_TYPES.INPUT}
									label={'EMAIL'}
									name='email'
									value={email}
									validations={emailValidations}
									onChange={onChange}
								/>
								<div className='description-body'>
									<TextInput
										placeholder='Please be as descriptive as possible.'
										type={INPUT_TYPES.TEXTAREA}
										label=''
										name='description'
										value={description}
										onChange={onChange}
										active={true}
										setDefaultValueAsPlaceholder
										breakpoint={breakpoint}
										cypressId='feedback-description'
									/>
								</div>
							</div>
						</>
					)}
					{area === 'portal' && (
						<div className='success-wrapper'>
							You can create a ticket in our support section to contact our team directly.
							<div className='link' onClick={goToSupport}>
								Click here to be taken there.
							</div>
						</div>
					)}
					{success && !error && (
						<div className='success-wrapper'>
							Thanks for submitting your issue. Our support team will contact you soon.
						</div>
					)}
					{!success && error && (
						<div className='success-wrapper'>Error submitting ticket. Please try again later.</div>
					)}
				</div>
			</ScrollView>
		</HelpBodyStyle>
	);
};
